import React from "react";
import { Search, ChevronRight, Plus, Menu } from "lucide-react";
import Logo from "./Logo";

import ThemeToggle from "../../shared/components/ThemeToggle";

const DashboardHeader = ({
  userEmail: userEmailProp,
  userMeta,
  isProfileOpen,
  setIsProfileOpen,
  profileMenuRef,
  onLogout,
  setIsAccountSettingsOpen,
  searchTerm,
  setSearchTerm,
  handleSearchSubmit,
  openNewCaseModal,
  onMenuClick,
}) => {
  // Handle both string and object formats for userEmail
  const userEmail = typeof userEmailProp === 'object' ? userEmailProp?.email : userEmailProp;

  return (
    <header className="h-16 border-b dark:border-slate-800 border-slate-200 flex items-center justify-between px-4 sm:px-6 dark:bg-slate-900/50 bg-white/80 backdrop-blur-sm relative z-50 transition-colors duration-300">
      <div className="flex items-center gap-3 flex-1">
        <button
          onClick={onMenuClick}
          className="md:hidden dark:text-slate-400 text-slate-600 hover:text-slate-900 dark:hover:text-white p-1 -ml-2 mr-2"
        >
          <Menu className="w-6 h-6" />
        </button>
        <form onSubmit={handleSearchSubmit} className="relative w-full max-w-md hidden sm:block">
          <Search className="w-4 h-4 dark:text-slate-500 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
          <input
            type="text"
            placeholder="Search borrowers or case numbers..."
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            className="w-full dark:bg-slate-900 bg-slate-100 border dark:border-slate-700 border-slate-200 rounded-full pl-9 pr-3 py-1.5 text-sm dark:text-slate-300 text-slate-700 focus:border-yellow-500 focus:outline-none transition-all duration-200 placeholder-slate-400"
          />
        </form>
        <button
          onClick={openNewCaseModal}
          className="px-3 py-1.5 bg-yellow-600 text-white rounded-lg text-sm font-semibold hover:bg-yellow-500 transition-colors sm:hidden"
        >
          New
        </button>
        <div className="flex items-center gap-3 sm:gap-4 ml-auto">
          <ThemeToggle />
        </div>
        <div className="relative" ref={profileMenuRef}>
          <button
            type="button"
            onClick={() => setIsProfileOpen((prev) => !prev)}
            className="flex items-center gap-2 dark:bg-slate-800/60 bg-white border dark:border-slate-700 border-slate-200 rounded-lg px-2 py-1 sm:px-2.5 sm:py-1.5 cursor-pointer hover:border-yellow-500 transition-colors shadow-sm"
          >
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-yellow-400 to-yellow-600 flex items-center justify-center text-xs font-bold text-white shadow-sm">
              {userEmail && userEmail.length > 0 ? userEmail[0].toUpperCase() : "U"}
            </div>
            <div className="hidden sm:flex flex-col leading-tight text-left">
              <span className="text-xs font-semibold dark:text-white text-slate-800 truncate max-w-[10rem]">
                {userEmail || userMeta.email || "User"}
              </span>
              <span className="text-xs dark:text-slate-400 text-slate-500">
                Membership: {userMeta.membership}
              </span>
            </div>
            <ChevronRight
              className={`w-3.5 h-3.5 dark:text-slate-400 text-slate-500 transition-transform ${isProfileOpen ? "rotate-90" : ""
                }`}
            />
          </button>
          {isProfileOpen && (
            <div className="absolute right-0 mt-2 w-72 dark:bg-slate-900 bg-white border dark:border-slate-800 border-slate-200 rounded-xl shadow-2xl overflow-hidden z-30">
              <div className="px-4 py-3 border-b dark:border-slate-800 border-slate-100 dark:bg-slate-900/50 bg-slate-50/50">
                <p className="text-sm font-semibold dark:text-white text-slate-900 truncate">
                  {userEmail || userMeta.email || "User"}
                </p>
                <p className="text-xs dark:text-slate-400 text-slate-500 truncate">
                  Membership: {userMeta.membership}
                </p>
                <p className="text-xs dark:text-slate-400 text-slate-500 truncate">
                  Credits: {userMeta.credit ?? 0}
                </p>
              </div>
              <div className="divide-y dark:divide-slate-800 divide-slate-100">
                <button
                  type="button"
                  className="w-full text-left px-4 py-3 text-sm dark:text-slate-200 text-slate-700 hover:bg-slate-800/70 dark:hover:bg-slate-800 hover:bg-slate-50 transition-colors"
                  onClick={() => {
                    setIsProfileOpen(false);
                    setIsAccountSettingsOpen(true);
                  }}
                >
                  Account settings
                </button>
                <button
                  type="button"
                  className="w-full text-left px-4 py-3 text-sm text-red-400 hover:bg-red-500/10 transition-colors flex items-center gap-2"
                  onClick={onLogout}
                >
                  <ChevronRight className="w-4 h-4" />
                  Sign out
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
